import React from "react";
import { useLanguage } from "../LanguageProvider";

export default function MuszakiModalContent() {
  const { dict } = useLanguage();
  const t = dict.tech;

  return (
    <div className="text-white text-lg md:text-xl space-y-6 w-full">
      <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-white">{t.title}</h2>
      <section>
        <h3 className="text-white text-lg font-semibold mt-4 mb-1">{t.basePrices}</h3>
        <ul className="list-disc list-inside space-y-1 text-white">
          <li className="text-white">{t.netArea}</li>
          <li className="text-white">{t.grossArea}</li>
        </ul>
        <div className="text-white text-sm mt-1">{t.areaNote}</div>
        <div className="text-white mt-2">{t.roofExtra}</div>
        <div className="text-white mt-2">{t.vat}</div>
        <ul className="list-disc list-inside ml-4 text-white">
          <li className="text-white">{t.vat5}</li>
          <li className="text-white">{t.vat27}</li>
        </ul>
        <div className="text-sm text-white mt-1">{t.areaNote}</div>
        <div className="mt-2">{t.roofExtra}</div>
        <div className="mt-2">{t.vat}</div>
        <ul className="list-disc list-inside ml-4">
          <li>{t.vat5}</li>
          <li>{t.vat27}</li>
        </ul>
      </section>
      <section>
        <h3 className="text-lg font-semibold mt-4 mb-1 flex items-center gap-1">🔧 {t.includes}</h3>
        <ul className="list-none space-y-2">
          <li>
            <b>{t.structure}</b>
            <ul className="list-disc list-inside ml-4">
              {t.structureItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </li>
          <li>
            <b>{t.insulation}</b>
            <ul className="list-disc list-inside ml-4">
              {t.insulationItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </li>
          <li>
            <b>{t.waterproof}</b>
          </li>
          <li>
            <b>{t.exterior}</b><br/>
            <span className="ml-2">{t.exteriorExtra}</span>
          </li>
          <li>
            <b>{t.interior}</b>
            <ul className="list-disc list-inside ml-4">
              {t.interiorItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </li>
          <li>
            <b>{t.electric}</b>
            <ul className="list-disc list-inside ml-4">
              {t.electricItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </li>
          <li>
            <b>{t.heating}</b><br/>
            <span className="ml-2">{t.heatingExtra}</span>
          </li>
          <li>
            <b>{t.coverings}</b>
            <ul className="list-disc list-inside ml-4">
              {t.coveringsItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </li>
          <li>
            <b>{t.partitions}</b><br/>
            <span className="ml-2">{t.partitionsExtra}</span>
          </li>
          <li>
            <b>{t.doors}</b><br/>
            <span className="ml-2">{t.doorsExtra}</span>
          </li>
          <li>
            <b>{t.plumbing}</b>
          </li>
        </ul>
      </section>
      <section>
        <h3 className="text-lg font-semibold mt-4 mb-1 flex items-center gap-1">🎁 {t.optionalTitle}</h3>
        <ul className="list-disc list-inside ml-4 space-y-1">
          {t.optionalItems.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>
      <section>
        <h3 className="text-lg font-semibold mt-4 mb-1 flex items-center gap-1">ℹ️ {t.otherTitle}</h3>
        <ul className="list-disc list-inside ml-4 space-y-1">
          {t.otherItems.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>
    </div>
  );
}
